import { Box, Typography } from '@mui/material';
import { memo, useCallback, useMemo } from 'react';
import NavGroup from './NavGroup';
import menuConfig from '../../../../../config/menu.config';

const Navigation = () => {
  const renderNavItem = useCallback(({ type, id, ...rest }) => {
    switch (type) {
      case 'group':
        return <NavGroup key={id} item={{ id, type, ...rest }} />;
      default:
        return (
          <Typography
            key={id}
            variant="h6"
            color="error"
            align="center"
            className="nav-error"
          >
            Fix - Navigation Group
          </Typography>
        );
    }
  }, []);

  const navGroups = useMemo(() => {
    return renderNavItem(menuConfig);
  }, [renderNavItem]);

  return (
    <Box
      component="nav"
      sx={{
        overflow: "clip",
        height: "100%",
        overflowY: "scroll",
        position: "relative"
      }}
      role="navigation"
    >
      {navGroups}
    </Box>
  );
};

// Prevent unnecessary re-renders
export default memo(Navigation);
